export const FEATURES = {
  AUTOMATION_BOT_CONNECTORS: 'Automation.Bot_Connectors',
  AUTOMATION_CONVERSATION_BULDER: 'Automation.Conversation_Builder',
  INTELLIGENCE_ANALYZER_ACCESS_LPA: 'Intelligence.intentAnalyzerAccessLPAOnly',
  INTELLIGENCE_PORTAL_ACCESS: 'Intelligence.portalAccess',
  INTELLIGENCE_PORTAL_ACCESS_LPA_ONLY: 'Intelligence.portalAccessLPAOnly',
  INTELLIGENCE_PROVISION_TRIAL: 'Intelligence.intentAnalyzerProvisionalTrial',
  INTELLIGENCE_CONTRACT_SIGNED: 'Intelligence.intentAnalyzerContractSigned',
  INTELLIGENCE_SELF_SERVICE_TRIAL: 'Intelligence.intentAnalyzerSelfServiceTrial',
  INTELLIGENCE_AI_ANNOTATOR: 'Intelligence.aiAnnotatorAccessInsideIntentAnalyzer',
  INTELLIGENCE_HANDLE_INTENT_ANNOTATIONS: 'Tasks.Handle_Intent_Annotaitons',
  INTELLIGENCE_HANDLE_FALSE_RESPONSE: 'Tasks.Handle_False_Responses',
  INTELLIGENCE_PERFORMANCE_PORTAL_ACCESS: 'Intelligence.performancePortalAccess',
  INTELLIGENCE_DATA_TRANSPORTER_ACCESS: 'Intelligence.dataTransporterAccess',
  AIAUTOMATION_GENERATIVEAI_PREVIEW: 'AIAutomation.GenerativeAI_Preview',
  AIAUTOMATION_GENERATIVEAI: 'AIAutomation.GenerativeAI',
  LLM_AGREEMENT_INFO_SITE_SETTING: 'lp.llm.agreementInfo',
};

export default FEATURES;
